/** A bid package as the planner names it: "{number} | {title}", or whichever
 *  of the two it has. */
export function bidPackageLabel(
  number: string | null | undefined,
  title: string | null | undefined
): string {
  return [number?.trim(), title?.trim()].filter(Boolean).join(" | ");
}
